import React from 'react'
import { motion } from 'framer-motion'
import architectImage from '../assets/arcitect.png'
import fightImage from '../assets/fight.png'
import blacksmithImage from '../assets/blacksmith.png'


const Values = () => {


  return (
    <>
      <div className='w-full'>
        <div className='max-w-[1240px] mx-auto'>
            <div className='p-10 sm:p-20 grid grid-cols-1 md:grid-cols-2 gap-x-8 content-start '>
          <div className='md:mt-48'>
            <h1 className='text-3xl md:text-5xl font-bold'>Core Values and Mission</h1>
            <p className='text-2xl py-5 md:py-10'>
              We strongly believe in building for the community. The overall mission is to onboard users to Ethereum and further the movement of Blockchain adoption through art and software deliverables.
            </p>
          </div>

          <div>
            <img className="w-[600px]" src={blacksmithImage} alt="" />
          </div>
        </div>
          <motion.div
                  initial={{ y: -200, opacity: 0 }}
                  transition={{ delay: 0.25, duration: 0.5 }}
                  whileInView={{ opacity: 1, y: 0}}
                  viewport={{ once: true }}
          >
          </motion.div>
          <div className='grid sm:grid-cols-1 md:grid-cols-2 mt-32'>
            <img className="w-[600px]" src={architectImage} alt="" />
            <img className="w-[600px]" src={fightImage} alt="" />
          </div>
        </div> 
      </div>  
    </>
  )
}

export default Values